import { useDownloadMutation } from '~/hooks/common';
import { axiosInstance, downloadBlobDataFile } from '~/services';

import { API_ENDPOINT } from '~/constants';

import type { TypeGetReceivingReportHistoriesParams } from '~/types/receive.types';

type TypeGetReportHistoriesDownloadMutationParams = TypeGetReceivingReportHistoriesParams & {
  ownerCode: string;
};

const fetchReportHistoriesDownload = async ({
  ownerCode,
  ...params
}: TypeGetReportHistoriesDownloadMutationParams): Promise<void> => {
  const response = await axiosInstance.get(
    `${API_ENDPOINT.RECEIVE.GET_REPORT_HISTORIES_DOWNLOAD}/${ownerCode}/report/histories/download`,
    {
      params,
      responseType: 'blob',
    }
  );

  downloadBlobDataFile(response);
};

/**
 * [입고관리 > 입고 리포트 관리] 입고 리포트 엑셀 다운로드 Mutation Hook
 */
export const useGetReportHistoriesDownloadMutation = () => {
  return useDownloadMutation(fetchReportHistoriesDownload);
};
